import type { IsoTimestamp } from '~/types/dates'

/**
 * Fields carried by every persisted record (D-027).
 *
 * `schemaVersion` records the database version at last write, so a record can
 * be interpreted even if it was written by an older build and has not yet been
 * touched by a migration.
 */
export interface RecordEnvelope {
  readonly createdAt: IsoTimestamp
  readonly updatedAt: IsoTimestamp
  readonly schemaVersion: number
}

/** A validation failure, naming the field so the UI can point at it. */
export interface ValidationIssue {
  readonly field: string
  readonly message: string
}

export type ValidationIssues = readonly ValidationIssue[]

export function issue(field: string, message: string): ValidationIssue {
  return { field, message }
}

/**
 * Placeholder value type for stores whose entity is modelled in a later
 * checkpoint. Keeping the store in the v1 schema is deliberate — changing store
 * structure later is the expensive operation, so all 14 stores are created up
 * front (D-027).
 */
export interface UnmodelledRecord {
  readonly id: string
  readonly [field: string]: unknown
}
